import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ModalService } from 'src/app/services/modal.service';
@Component({
  selector: 'app-ai-powered-nlp',
  templateUrl: './ai-powered-nlp.component.html',
  styleUrls: ['./ai-powered-nlp.component.scss']
})
export class AIPoweredNLPComponent implements OnInit {
  certificateImage = 'assets/img/live-courses/certificate/AI-Powered-NLP.png';
  course_details = environment.course_date_advanced_data_science_and_AI;
  course_date_month = environment.course_date_month;
  course_class_mode_text = [
    '🔴 Live Interactive Sessions',
    '🎥 Access to Class Recordings',
    '❓Dedicated Doubt Support',
    '🏆 Course Certification',
    '🛠 Hands-on Project Work',
    '🎁 Final Project and Exciting Goodies'
  ]
  currentTextIndex: number = 0;
  classFeature: string = this.course_class_mode_text[this.currentTextIndex];
  mentor = {
    name: 'Manan Gupta',
    title2: '',
    title: 'Associate Software Developer at JPMorgan Chase & Co.',
    image: 'assets/img/live-courses/manan.jpeg', // Update with actual image path
    linkedinUrl: 'https://www.linkedin.com/in/manan-gupta-167a9914a/'
  };

  stats = [
    { value: '2,000+', label: 'Students Mentored' },
    { value: 'JPMorgan Chase & Co.', label: 'Associate Software Developer' },
  ];
  constructor(
    private modalService: ModalService) { }

  ngOnInit(): void {
    setInterval(() => {
      this.currentTextIndex = (this.currentTextIndex + 1) % this.course_class_mode_text.length;
      this.classFeature = this.course_class_mode_text[this.currentTextIndex];
    }, 3000);
  }


  moduleArray = [
    {
      id: 1,
      active: false,
      courseTopic: 'NLP Fundamentals & Classical Approaches',
      timeTaking: '1st week',
      isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Establish a robust data-driven groundwork with the first module, Foundations of Data Science.',
          moduleContant: [
            'Introduction to NLP & Real-World Applications',
            'Text Processing: Tokenization, Stemming, Lemmatization',
            'Word Embeddings: Word2Vec, GloVe, FastText',
            'Named Entity Recognition (NER) & Part-of-Speech (POS) Tagging',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Build a text classification model for sentiment analysis (e.g., movie reviews, Twitter sentiment, or customer feedback analysis).'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 2,
      active: false,
      courseTopic: 'Sequence Models & Traditional NLP Techniques',
      timeTaking: '2nd week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Navigate the realm of Statistical Thinking and Descriptive Analysis, gaining insights into data through analytical techniques and methodologies in our comprehensive course module.',
          moduleContant: [
            'Introduction to Sequence Models(RNNs, LSTMs, GRUs)',
            'Text Generation using RNNs',
            'Language Modeling & Word Prediction',
            'Attention Mechanism & Seq2Seq Models',

          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Develop a text generator using LSTMs (e.g., generate poetry, song lyrics, or short stories).'
              ]
            }

          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 3,
      active: false,
      courseTopic: 'Transformers & Large Language Models',
      timeTaking: '3rd week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: 'Dive into the core principles of Machine Learning with our module, exploring fundamental algorithms and techniques to empower your understanding and application of this transformative field.',
          moduleContant: [
            'Introduction to Transformer Architecture (Self-Attention, Multi-Head Attention)',
            'Pretrained Models: BERT, GPT, T5, XLNet',
            'Fine-tuning vs Zero-shot/Few-shot Learning',
            'Hands-on with Hugging Face & OpenAI API',

          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Fine-tune BERT for a custom NLP task (e.g., question answering, text summarization, or intent classification).'
              ]
            }

          ],

          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        }
      ]
    },
    {
      id: 4,
      active: false,
      courseTopic: 'AI-Powered Chatbots & Conversational AI',
      timeTaking: '4th week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: `Explore the forefront of data science with the Advanced Data Science Techniques module, encompassing advanced methods, NLP, and Deep Learning strategies to tackle complex challenges and extract profound insights from diverse datasets.`,
          moduleContant: [
            'Chatbot Architecture: Rule-Based vs AI-Driven',
            'Intent Recognition & Contextual Understanding',
            'Retrieval-Augmented Generation (RAG) in Chatbots',
            'Speech-to-Text & Text-to-Speech (STT & TTS)',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Build an AI-powered chatbot using GPT-4 (e.g., customer support bot, medical assistant, or legal advisor).'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    },
    {
      id: 5,
      active: false,
      courseTopic: 'LLMs and the Language Frontier',
      timeTaking: '5th week',
        isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: `Embark on an exploration of Language Models and the Language Frontier in our fourth module, delving into the cutting-edge realms of NLP and Deep Learning to master language processing techniques and advance your data science skills.`,
          moduleContant: [
            'Multilingual NLP & Cross-Language Understanding',
            'AI for Code Generation (Codex, ChatGPT, Gemini)',
            'Bias & Fairness in NLP Models',
            'NLP in Search Engines & Recommendation Systems',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Develop an AI-powered text summarization tool (e.g., summarizing research papers, news articles, or legal documents).'
              ]
            }
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    },
    {
      id: 6,
      active: false,
      courseTopic: 'AI Ethics, Explainability, and Final Project',
      timeTaking: '6th week',
      isProjectInclude: true,
      childProperties: [
        {
          id: 1,
          module_description: `Empower yourself in the art of AI innovation with 'Building Your Own GPT/LLM Model' module, guiding you through the process of constructing and customizing your language model for a personalized and impactful data science journey.`,
          moduleContant: [
            'Ethical AI & Bias in NLP',
            'Explainability in NLP Models (SHAP, LIME)',
            'Future of NLP & Industry Trends',
          ],
          project: [
            {
              projectName: '',
              title: '',
              pType: [
                'Develop an NLP-powered application (e.g., AI-powered resume screener, chatbot for legal queries, or an intelligent Q&A system).'
              ]
            },
          ],
          outComes: 'After this module you will be understanding the fundamentals of programming and basics of Data Structures and Time Complexity.'
        },

      ]
    },
   
  ]

  toggleCourseTitle(selectedData, index) {
    for (let i = 0; i < this.moduleArray.length; i++) {
      if (this.moduleArray[i].id == selectedData.id) {
        this.moduleArray[i].active = !this.moduleArray[i].active;
      } else {
        this.moduleArray[i].active = false;
      }
    }
  }

  downloadBroucher() {
    this.modalService.openModal();
  }
}
